function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.77 24.554L12.304 7.65c-.256 1.27-.47 2.393-.66 3.39l-.194 1.01c-.298 1.55-.549 2.78-.83 3.717-.275.922-.62 1.707-1.197 2.246-.622.58-1.38.756-2.193.756H5.538a.923.923 0 010-1.846H7.23c.543 0 .774-.111.934-.26.204-.19.434-.577.688-1.425.25-.832.483-1.969.786-3.537l.191-1.002c.256-1.342.56-2.933.948-4.8l.076-.296a1.54 1.54 0 012.957.2v.003l3.491 17.023 2.272-9.467a1.543 1.543 0 011.386-1.178 1.539 1.539 0 011.519.914l.073.182c.128.325.25.658.364.968.073.198.143.388.209.56.193.507.368.92.563 1.252.192.327.378.532.57.66.181.119.422.206.794.206h1.41a.923.923 0 010 1.846h-1.41c-.692 0-1.296-.172-1.811-.512-.504-.334-.865-.79-1.145-1.266-.277-.471-.497-1.005-.697-1.53-.08-.212-.157-.418-.232-.623l-.03-.081-2.363 9.846a1.538 1.538 0 01-3.003-.052z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 6a5 5 0 015-5h20a5 5 0 015 5v20a5 5 0 01-5 5H6a5 5 0 01-5-5V6zm5-3a3 3 0 00-3 3v20a3 3 0 003 3h20a3 3 0 003-3V6a3 3 0 00-3-3H6z",
  fill: "currentColor"
})));